"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearerAuthProfile = void 0;
class BearerAuthProfile {
    constructor(token) {
        this.headers = { Authorization: getBearerAuthHeader(token) };
    }
    getAuthHeaders() {
        return { ...this.headers };
    }
}
exports.BearerAuthProfile = BearerAuthProfile;
function getBearerAuthHeader(token) {
    return `Bearer ${token}`;
}
//# sourceMappingURL=bearer-auth.profile.js.map